<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide()" :mask-closable="false" width="950">

            <Divider orientation="left">订单信息</Divider>
            <Row :gutter="16">
                <Col span="8">
                    <div>订单编号：{{ orderInfo.recoveryOrder.orderCode }}</div>
                </Col>
                <Col span="8">
                    <div>订单标题：{{ orderInfo.recoveryOrder.orderTitle }}</div>
                </Col>
                <Col span="8">
                </Col>
                <Col span="8">
                  <div>下单昵称：{{ orderInfo.recoveryOrder.nickName }}</div>
                </Col>
            </Row>
            <Row :gutter="16">
              <Col span="8">
                  <div>订单总额：{{ orderInfo.recoveryOrder.totalAmount ? '￥' + orderInfo.recoveryOrder.totalAmount : '-' }}
                  </div>
              </Col>
              <Col span="8">
                <div>
                  总重量：{{orderInfo.recoveryOrder.totalWeight ? orderInfo.recoveryOrder.totalWeight : '-'}}
                  <span v-if="orderInfo.recoveryOrder.totalWeight && categoryUnit == 1">公斤</span>
                  <span v-if="orderInfo.recoveryOrder.totalWeight && categoryUnit == 2">个</span>
                </div>
              </Col>
                <Col span="8">
                    <div>赠送积分：{{ orderInfo.recoveryOrder.integral ? orderInfo.recoveryOrder.integral : '-' }}</div>
                </Col>
            </Row>
            <Row :gutter="16">
              <Col span="8">
                <div>创建时间：{{ orderInfo.recoveryOrder.createTime }}</div>
              </Col>
              <Col span="8">
                <div>取消时间：{{ orderInfo.recoveryOrder.cancelTime ?  orderInfo.recoveryOrder.cancelTime : '-'}}</div>
              </Col>
              <Col span="8">
                <div>
                  订单状态：
                  <template v-if="orderInfo.recoveryOrder.orderState == 1">待确认</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 2">待回收</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 3">运输中</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 4">待验收</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 5">已完成</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 6">已取消</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 7">揽件失败</template>
                  <template v-if="orderInfo.recoveryOrder.orderState == 8">快递方取消</template>
                </div>
              </Col>
            </Row>
            <Row :gutter="16">
              <Col span="8">
                <div>
                  预估重量：{{
                    orderInfo.recoveryOrder.estimateWeight ? orderInfo.recoveryOrder.estimateWeight : '-'
                  }}
                </div>
              </Col>
              <Col span="8">
                <div>
                  订单备注：{{
                    orderInfo.recoveryOrder.remark ? orderInfo.recoveryOrder.remark : '-'
                  }}
                </div>
              </Col>
            </Row>
            <Row :gutter="16">
              <Col span="8">
                <div>用户上传图片：
                  <div class="" style="margin-right: 10px"  v-for="(v,i) in formatImage(orderInfo.recoveryOrder.userImg)"
                       :key="i" @click="previewImage(formatImage(orderInfo.recoveryOrder.userImg))">
                    <img :src="v" style="width: 100px; height: 100px;">
                  </div>
                </div>
              </Col>
            </Row>
          <Divider orientation="left">地址信息</Divider>
          <template>
            <Row :gutter="16">
              <Col span="8">
                <div >用户姓名：{{ orderInfo.address.realName }}</div>
              </Col>
              <Col span="8">
                <div>用户手机号：{{ orderInfo.address && orderInfo.address.mobile ? orderInfo.address.mobile : '-' }}</div>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <div>用户地址：<span style="color: #2baee9;cursor:pointer" @click="showOrderInfoMap">{{ orderInfo.address && orderInfo.address.locationAddress }} {{ orderInfo.address && orderInfo.address.address }}</span></div>
              </Col>
            </Row>
            <Row :gutter="16">
              <Col span="8">
                <div >仓库名称：{{ orderInfo.warehouse && orderInfo.warehouse.warehouseName }}</div>
              </Col>
              <Col span="8">
                <div>仓库联系人：{{ orderInfo.warehouse && orderInfo.warehouse.contact ? orderInfo.warehouse.contact : '-' }}</div>
              </Col>
              <Col span="8">
                <div>仓库联系方式：{{ orderInfo.warehouse && orderInfo.warehouse.mobile ? orderInfo.warehouse.mobile : '-' }}</div>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <div>仓库地址：{{ orderInfo.warehouse && orderInfo.warehouse.address }}</div>
              </Col>
            </Row>
          </template>

            <Divider orientation="left">快递信息</Divider>
            <Row :gutter="16">
                <Col span="8">
                    <div>
                      快递公司：{{
                        orderInfo.orderLogistics && orderInfo.orderLogistics.logisticsName ? orderInfo.orderLogistics.logisticsName : '-'
                        }}
                    </div>
                </Col>
                <Col span="8">
                    <div>
                        快递单号：<span style="color: #2baee9;cursor:pointer" @click="showLogistics">
                      {{ orderInfo.orderLogistics && orderInfo.orderLogistics.mailNo ? orderInfo.orderLogistics.mailNo : '-'}}</span>
                    </div>
                </Col>
              <Col span="8">
                <div>
                  快递员：
                  {{
                    orderInfo.orderLogistics && orderInfo.orderLogistics.courierName ? orderInfo.orderLogistics.courierName : '-'
                  }}
                </div>
              </Col>
            </Row>
          <Row :gutter="16">
            <Col span="8">
              <div>
                快递员联系电话：
                {{
                  orderInfo.orderLogistics && orderInfo.orderLogistics.courierPhone ? orderInfo.orderLogistics.courierPhone : '-'
                }}
              </div>
            </Col>
            <Col span="8">
              <div>
                快递反馈重量：{{
                  orderInfo.orderLogistics && orderInfo.orderLogistics.expressWeight ? orderInfo.orderLogistics.expressWeight : '-'
                }} KG
              </div>
            </Col>
          </Row>

            <Divider orientation="left">回收质检信息</Divider>
          <Row>
            <Col span="24">
              <div style="margin-left: 110px; margin-bottom: 10px;">
                质检状态：
                <Tag checkable color="green" v-if="orderInfo.recoveryOrder.isPass == 1">合格</Tag>
                <Tag checkable color="red" v-if="orderInfo.recoveryOrder.isPass == 0">不合格</Tag>
              </div>
            </Col>
          </Row>
            <Row v-for="(item,index) in orderInfo.recoveryOrderItem" :key="index">
                <Col span="9" style="margin-top: 10px">
                  <div class="j-order-image">
                    <div class="j-order-image-main">
                      <img :src="item.categoryImage">
                    </div>
                    <div class="j-order-image-info">
                      <div class="j-order-goods-title">
                        {{ item.categoryName }}
                        <template v-if="item.lowerCategoryName">
                          - {{ item.lowerCategoryName }}
                        </template>
                      </div>
                      <div class="j-order-goods-price">回收单价：{{ item.unitPrice }}元</div>
                      <div class="j-order-goods-price">回收重量：{{ item.weight }} {{ item.categoryUnit === 1 ? '公斤' : '个'}}</div>
                    </div>
                  </div>
                </Col>
                <Col span="15">
                    <div class="j-order-image" style="margin-top: 5px">
                        <div class="j-order-image-main" style="margin-right: 10px"
                             v-for="(v,i) in formatImage(item.orderImage)" :key="i"
                             @click="previewImage(formatImage(item.orderImage))">
                            <img :src="v">
                        </div>
                    </div>
                </Col>
            </Row>
          <!-- 图片预览弹窗 -->
            <viewer :images="images" class="viewer" ref="viewer" @inited="inited" v-show="showImage">
                <template scope="scope">
                    <img v-for="src in scope.images" :src="src+`?${Date.now}`" :key="src">
                    {{ scope.options }}
                </template>
            </viewer>

            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button type="primary" @click="hide()" :loading="loadingBtn">
                    <span v-if="!loadingBtn">确定</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
      <order-info-map ref="orderInfoMap"></order-info-map>
      <order-logistics-tracking ref="orderLogisticsTracking"></order-logistics-tracking>
    </div>
</template>

<script>
import orderInfoMap from './order-info-map';
import orderLogisticsTracking from './order-logistics-tracking.vue';
export default {
    data() {
        return {
            isShowModal: false,
            loadingBtn: false,
            orderInfo: {
                recoveryOrder: {},
                address: {},
                recoveryOrderItem: []
            },
            title: '订单详情',
            images: [],
            showImage: false,
            categoryUnit: 1,
        }
    },
    methods: {
        // 显示模态框
        show(row) {
            this.isShowModal = true;
            this.getInfo(row);
        },
        // 查询订单详情
        getInfo(row) {
            this.$Spin.show();
            this.axios.post('/recoveryOrder/getInfo', {
                recoveryOrderId: row.recoveryOrderId
            }).then(res => {
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (res.status == 200) {
                    // this.$Message.success('操作成功.');
                    this.orderInfo = res.data;
                    if (this.orderInfo.recoveryOrderItem[0].categoryUnit) {
                      this.categoryUnit = this.orderInfo.recoveryOrderItem[0].categoryUnit
                    }
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '查看订单详情接口报错',
                        duration: 0
                    });
                }
            })
        },
      // 查询物流消息
      getStandTraceSubscribe(wayBillNo) {
        this.axios.post('/recoveryOrder/standTraceSubscribe', {
          wayBillNo: wayBillNo
        }).then(res => {
          if (res.status == 200) {
            // this.$Message.success('操作成功.');
          }
          if (res.status == 500) {
            this.$Notice.error({
              title: '服务器内部错误',
              desc: '查看订单详情接口报错',
              duration: 0
            });
          }
        })
      },
        inited(viewer) {
            this.$viewer = viewer
        },
        previewImage(images) {
            this.images = images;
            this.$viewer.show();
        },
        // 格式化图片
        formatImage(image) {
            if (image) {
                return image.split(',')
            }
        },
        // 关闭模态框
        hide() {
            this.isShowModal = false;
        },
        // 计算
        ride(e) {
          return e * 100
        },
        showOrderInfoMap() {
          this.$refs.orderInfoMap.show(this.orderInfo);
        },
      showLogistics() {
        this.$refs.orderLogisticsTracking.show(this.orderInfo);
      },
    },
    components: {
      orderInfoMap,
      orderLogisticsTracking
    }
}
</script>

<style scoped lang="less">
.j-order-image {
    display: flex;

    .j-order-image-main {
        width: 100px;
        height: 100px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .j-order-image-info {
        margin-left: 10px;

        .j-order-goods-title {
          font-weight: bold;
        }

        .j-order-goods-sku {
            margin-top: 5px;
        }

        .j-order-goods-price {
            margin-top: 5px;
        }

        .j-order-goods-num {
            margin-top: 5px;
        }
    }
}
.weightColor {
  color: red;
}
</style>